import {
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import VideoProductionChildContent from "./VideoProductionChildContent";
import VideoProductionChildTrigger from "./VideoProductionChildTrigger";
import { useState, useCallback, useRef } from "react";

export default function VideoProductionChildItem({
  child,
  isOpen,
  isCurrentChild,
}: any) {
  const [isDirty, setIsDirty] = useState(false);
  const updateFnRef = useRef<(() => void) | null>(null);

  const onDirtyChange = useCallback((dirty: boolean) => setIsDirty(dirty), []);
  const onRegisterUpdate = useCallback((fn: (() => void) | null) => {
    updateFnRef.current = fn;
  }, []);

  const handleUpdateClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    updateFnRef.current?.();
  };

  return (
    <AccordionItem
      key={child.id}
      value={String(child.id)}
      className={`border rounded-[14px] mb-2 px-3 py-2.5 last:border-b overflow-hidden ${
        isCurrentChild
          ? "border-[var(--color-primary)]/30 ring-1 ring-[var(--color-primary)]/15"
          : "border-[var(--color-black-1)]"
      } ${child.isFroze ? "bg-[#fafafa]" : ""}`}
      style={
        !child.isFroze
          ? {
              backgroundImage: isCurrentChild
                ? "linear-gradient(177.477deg, rgb(228, 245, 238) 11.475%, rgb(245, 255, 250) 52.352%)"
                : "linear-gradient(177.477deg, rgb(237, 250, 245) 11.475%, rgb(255, 255, 255) 52.352%)",
            }
          : undefined
      }
    >
      <AccordionTrigger className="hover:no-underline py-0">
        <VideoProductionChildTrigger
          child={child}
          isOpen={isOpen}
          isDirty={isDirty}
          onUpdateClick={handleUpdateClick}
        />
      </AccordionTrigger>

      <VideoProductionChildContent
        child={child}
        onDirtyChange={onDirtyChange}
        onRegisterUpdate={onRegisterUpdate}
      />
    </AccordionItem>
  );
}
